/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TagSection } from '../../models/tag-section';

export interface VaultGetTags$Params {

/**
 * GUID of the vault
 */
  vaultId: string;
}

export function vaultGetTags(http: HttpClient, rootUrl: string, params: VaultGetTags$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TagSection>>> {
  const rb = new RequestBuilder(rootUrl, vaultGetTags.PATH, 'get');
  if (params) {
    rb.path('vaultId', params.vaultId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TagSection>>;
    })
  );
}

vaultGetTags.PATH = '/vault/{vaultId}/tag/list';
